// extracted by mini-css-extract-plugin
export var centerText = "_d7-8";
export var container = "_d7-0";
export var doughnutContainer = "_d7-7";
export var legend = "_d7-a";
export var legendItemColorDisplay = "_d7-b";
export var legendItemLabel = "_d7-d";
export var legendItemValue = "_d7-c";
export var lg = "_d7-5";
export var maxWidth = "_d7-9";
export var md = "_d7-4";
export var responsive = "_d7-6";
export var sm = "_d7-3";
export var xs = "_d7-2";
export var xxs = "_d7-1";